<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm" style="height: max-content; width: 50rem; padding: 1rem 2rem; border-radius: 5px;" @click.stop>
            <div>
                <h3>Editar: {{ backlog?.codigo }} </h3>
            </div>
            <hr>
            <br>
            <div class="grid-2">
                <div>
                    <label>Descrição</label>
                    <textarea v-model="localBacklog.descricao"
                        @focusout="$emit('editar', 'descricao', localBacklog.id, localBacklog.descricao)"></textarea>
                </div>
                <div>
                    <label>Responsável</label>
                    <select v-model="localBacklog.responsavel_id"
                        @change="$emit('editar', 'responsavel_id', localBacklog.id, localBacklog.responsavel_id)">
                        <option v-for="item in gerente" :key="item.id" :value="item.id">
                            {{ item.nomeCompleto }}
                        </option>
                    </select>
                </div>
                <div class="grid-2">
                    <div>
                        <label>Início Previsto</label>
                        <input v-model="localBacklog.dtInicio" type="date"
                            @change="$emit('editar', 'dtInicio', localBacklog.id, localBacklog.dtInicio || null)">
                    </div>
                    <div>
                        <label>Fim Previsto</label>
                        <input v-model="localBacklog.dtFim" type="date"
                            @change="$emit('editar', 'dtFim', localBacklog.id, localBacklog.dtFim || null)">
                    </div>
                    <div>
                        <label>Inicio Real</label>
                        <input v-model="localBacklog.dtInicioReal" type="date"
                            @change="$emit('editar', 'dtInicioReal', localBacklog.id, dataHoraValor(localBacklog.dtInicioReal))">
                    </div>
                    <div>
                        <label>Fim Real</label>
                        <input v-model="localBacklog.dtFimReal" type="date"
                            @change="$emit('editar', 'dtFimReal', localBacklog.id, dataHoraValor(localBacklog.dtFimReal))">
                    </div>
                </div>
                <div>
                    <label>Observações</label>
                    <textarea v-model="localBacklog.obs" rows="6"
                        @focusout="$emit('editar', 'obs', localBacklog.id, localBacklog.obs)"></textarea>
                </div>
                <div class="col-2" style="margin-bottom: 0;">
                    <span>Anexos:</span>
                    <input style="display: none;" ref="fileInput" type="file" @change="onFileChange">
                    <ul style="list-style: none; margin-bottom: 0;" class="grid-3">
                        <li v-for="item in (backlog?.anexos ?? [])" :key="item.id">
                            <div class="anexo">
                                <a :href="urlFoto?.caminhoFoto + item.path" target="_blank">{{ item.nome ?? '-' }}</a>
                                <i @click="$emit('excluirAnexo', item.id)" style="color: red"
                                    class="bi bi-trash-fill botaoAdicionarSprint"></i>
                            </div>
                        </li>
                        <div @click="openFileInput" style="cursor: pointer" class="anexo">
                            Adicionar <i title="Adicionar anexo" class="bi bi-plus-circle"></i>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalEditarBacklogPAP",
    props: {
        mostrar: { type: Boolean, default: false },
        backlog: { type: Object, default: () => ({ anexos: [] }) },
        gerente: { type: Array, default: () => [] },
        urlFoto: { type: Object, default: () => ({ caminhoFoto: "" }) },
    },
    emits: ["fechar", "editar", "excluirAnexo", "uploadAnexos"],
    data() {
        return {
            localBacklog: {},
        };
    },
    watch: {
        backlog: {
            handler(val) {
                this.localBacklog = val ? { ...val } : {};
            },
            immediate: true,
            deep: true,
        },
        mostrar(visivel) {
            if (visivel && this.backlog) {
                this.localBacklog = { ...this.backlog };
            }
        },
    },
    methods: {
        openFileInput() {
            this.$refs.fileInput?.click();
        },
        dataHoraValor(d) {
            if (!d) return "";
            const t = new Date();
            return `${d} ${t.getHours()}:${t.getMinutes()}:${t.getSeconds()}`;
        },
        onFileChange(e) {
            const files = e.target?.files;
            if (files?.length) {
                this.$emit("uploadAnexos", files);
            }
            e.target.value = "";
        },
    },
};
</script>
